import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MdOutlineDarkMode, MdOutlineLightMode } from "react-icons/md";
import AboutPage from "./pages/AboutPage/AboutPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import ExperiencePage from "./pages/ExperiencePage";
import Homepage from "./pages/Homepage";
import ProjectPage from "./pages/ProjectPage";
import ProjectsPage from "./pages/ProjectsPage";
import ErrorLayout from "./components/ErrorLayout/ErrorLayout";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Message from "./components/Message/Message";

const App = () => {
  const [light, setLight] = useState(false);

  const toggleMode = () => {
    const element = document.body;
    element.classList.toggle("dark");
    setLight(!light);
  };

  return (
    <>
      <div>
        <span className="mode-position">
          {light ? (
            <MdOutlineDarkMode className="mode-icon" onClick={toggleMode} />
          ) : (
            <MdOutlineLightMode className="mode-icon" onClick={toggleMode} />
          )}
        </span>
        <BrowserRouter>
          <Routes>
            <Route element={<ErrorLayout />}>
              <Route exact path="/" element={<Homepage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/experiences" element={<ExperiencePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/success" element={<Message />} />
              <Route path="/project/:id" element={<ProjectPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
};

export default App;
